import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { ActionDateRange } from '#/modules/search/components/Facet/ActionDateRange';
import { LocaleFacet } from '#/modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from '#/modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from '#/modules/search/components/Facet/OrgAreasOfFocusFacet';
import { RecencyFacet } from '#/modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from '#/modules/search/components/Refinements/SearchRefinements';
import { EventSourceFacet } from '#/modules/search/events/components/EventSourceFacet';
import { IdealistDaysFilter } from '#/modules/search/events/components/IdealistDaysFilter';

export function SearchEventsRefinements() {
  const { locale } = useI18n();

  return (
    <SearchRefinements
      listingType="EVENT"
      renderFacets={({ variant }) => {
        switch (locale) {
          case I18nLocale.EN:
            return (
              <>
                <LocationTypeFacet variant={variant} />
                <IdealistDaysFilter variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <ActionDateRange variant={variant} />
                <EventSourceFacet variant={variant} />
                <LocaleFacet variant={variant} />
                <RecencyFacet variant={variant} />
              </>
            );

          case I18nLocale.ES:
            return (
              <>
                <LocaleFacet variant={variant} />
                <IdealistDaysFilter variant={variant} />
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <ActionDateRange variant={variant} />
                <EventSourceFacet variant={variant} />
                <RecencyFacet variant={variant} />
              </>
            );

          case I18nLocale.PT:
            return (
              <>
                <LocaleFacet variant={variant} />
                <IdealistDaysFilter variant={variant} />
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <ActionDateRange variant={variant} />
                <EventSourceFacet variant={variant} />
                <RecencyFacet variant={variant} />
              </>
            );
        }
      }}
    />
  );
}
